define('formkit/behavior/template.object.remove.reorder.behavior',['require','exports','module','marionette','../form.object.util','bluebird'],function(require, exports, module) {
  var Mn             = require('marionette');
  var FormObjectUtil = require('../form.object.util');
  var Promise = require('bluebird');

  var TemplateObjectReorderBehavior = Mn.Behavior.extend({

    defaults: {
      'enableActions': true,
      canRemoveOnlyChild: true,
      form: null
    },

    registeredEvents: false,

    onRender: function() {
      // make sure to only register events once
      if (this.registeredEvents) return;
      this.registeredEvents = true;

      this.setupActionsViewListener();
      this.updatePositionBasedActions();
    },

    modelEvents: {
      'move': 'updatePositionBasedActions',
      'add:sibling': 'updatePositionBasedActions',
      'remove:sibling': 'updatePositionBasedActions'
    },

    setupActionsViewListener: function() {
      this.listenTo(this.view, 'press', function(option) {
        if (this.getOption('form')) {
          this.getOption('form').executeTemplateObjectAction(option.get('action'), this.view.model);
        }
        else {
          Promise.reject(new Error('Error executing form action: form is null or undefined'));
        }
      });
    },

    updatePositionBasedActions: function() {
      if (!this.view.model)
        return;

      if (this.options.enableActions && this.view) {
        this.view.collection = this.generateControls(
          FormObjectUtil.isFirstChild(this.view.model),
          FormObjectUtil.isLastChild(this.view.model)
        );
      }
    },

    generateControls: function(isFirst, isLast) {
      var options = [];

      var onlyChild = isFirst && isLast;
      if (!onlyChild || this.options.canRemoveOnlyChild) {
        options.unshift({ text: 'Remove', action: 'remove' });
      }

      if (!isFirst) {
        options.unshift({ text: 'Move Up', action: 'moveUp' });
      }

      if (!isLast) {
        options.push({ text: 'Move Down', action: 'moveDown' });
      }

      return new Backbone.Collection(options);
    }
  });

  module.exports = TemplateObjectReorderBehavior;
});

